'use client';
import { useState } from 'react';

import { useMobile } from '@shared/hooks';

import { useGetAgreements } from './useGetAgreements';

export const useAgreements = () => {
  const {
    agreements: { data, isLoading: isGettingAgreements },
  } = useGetAgreements();

  const [collapseOpen, setCollapseOpen] = useState(false);
  const isMobile = useMobile();

  const toggleCollapse = () => setCollapseOpen((s) => !s);
  const resetCollapse = () => setCollapseOpen(false);

  return {
    agreements: data,
    isGettingAgreements,
    collapseOpen,
    toggleCollapse,
    resetCollapse,
    isMobile,
  };
};
